// @flow
import React from 'react';
import CancellationMessage from '../CancellationMessage/CancellationMessage';
import {UnitMessage} from '@homeaway/react-urgency-messaging';
type Badge = {
    id: string,
    name: string,
    helpText?: string
};
type IconText = {
    icon: string,
    message: string,
    messageValueType: string
};

type Message = {
    iconText: ?IconText
};

type Props = {
    freeCancellationBadge: Badge,
    message: Message
};

const UrgencyMessage = ({message, freeCancellationBadge}: Props) => {
    if (freeCancellationBadge) {
        return (
            <CancellationMessage
                freeCancellationBadge={freeCancellationBadge}
            />
        );
    }
    return (
        <UnitMessage
            className="HitInfo__content--urgency"
            size="s"
            unitMessage={message}
            ariaHidden
        />
    );
};

export default UrgencyMessage;
